import { Grid, TableRow } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectDropdownWidget } from 'src/components/widget';
import { ProjectConfigInterface } from 'src/interfaces';
import { lang } from 'src/utils';

import { generateDropDownOptions } from '../../EditAccessibilityPage.helper';
import {
  StyledInputContainer,
  StyledTableCell,
} from '../../EditAccessibilityPage.styled';
import { ComponentSettingsItemProps } from './ComponentSettingsItem.interface';

export const ComponentSettingsItem = (props: ComponentSettingsItemProps) => {
  const { control } = useFormContext<Partial<ProjectConfigInterface>>();
  const { isViewOnly } = props;

  return (
    <TableRow>
      <StyledTableCell width="30%">{props.label}</StyledTableCell>

      <StyledTableCell>
        <Grid container spacing={6}>
          {props.marginPath && (
            <Grid item xs={2}>
              <Controller
                key={props.marginPath}
                name={props.marginPath}
                control={control}
                render={({ field, fieldState }) => (
                  <StyledInputContainer>
                    <SelectDropdownWidget
                      {...field}
                      value={field.value}
                      selectOptions={generateDropDownOptions({
                        pxifyValue: false,
                        start: 0,
                      })}
                      hasError={!!fieldState.error}
                      error={fieldState.error ? lang.errors.required : false}
                      disabled={isViewOnly}
                    />
                  </StyledInputContainer>
                )}
              />
            </Grid>
          )}

          {props.paddingPath && (
            <Grid item xs={2}>
              <Controller
                key={props.paddingPath}
                name={props.paddingPath}
                control={control}
                render={({ field, fieldState }) => (
                  <StyledInputContainer>
                    <SelectDropdownWidget
                      {...field}
                      value={field.value}
                      selectOptions={generateDropDownOptions({
                        pxifyValue: false,
                        start: 0,
                      })}
                      hasError={!!fieldState.error}
                      error={fieldState.error ? lang.errors.required : false}
                      disabled={isViewOnly}
                    />
                  </StyledInputContainer>
                )}
              />
            </Grid>
          )}
        </Grid>
      </StyledTableCell>
    </TableRow>
  );
};
